// plan-02 S02: post-grade canvas mount — bible S13B

import { canvasSize } from './dpr'
import { createLoop, type DrawPass } from './loop'

export type { DrawPass }

export function mountPostgrade(
  canvas: HTMLCanvasElement,
  opts: { reduced: boolean; off: boolean },
): { stop: () => void; addPass: (pass: DrawPass) => void } {
  if (opts.off) return { stop() {}, addPass() {} }

  const ctx = canvas.getContext('2d', { alpha: true })
  if (!ctx) return { stop() {}, addPass() {} }

  const passes: DrawPass[] = []
  const getSize = () => canvasSize(canvas)

  getSize()

  let resizeTimer = 0
  const onResize = (): void => {
    clearTimeout(resizeTimer)
    resizeTimer = window.setTimeout(getSize, 100) as unknown as number
  }
  window.addEventListener('resize', onResize)

  const loop = createLoop(ctx, getSize, passes)
  loop.start()

  return {
    stop(): void {
      loop.stop()
      window.removeEventListener('resize', onResize)
    },
    addPass(pass: DrawPass): void {
      passes.push(pass)
    },
  }
}
